export function actionTypeToName(name){
  if(name === 'set') return 'Sets';
  if(name === 'collection') return 'Collection';
  if(name === 'makeType') return 'Make Type';
  if(name === 'subCategoryName') return 'Sub - Category';
  if(name === 'restrict') return 'Restrict Design';
  if(name === 'designClass') return 'Design Class';
}

export function actionTypeToRight(name){
  if(name === 'set') return 'Sets';
  if(name === 'collection') return 'Collection';
  if(name === 'makeType') return 'Make Type';
  if(name === 'subCategoryName') return 'Sub-Category';
  if(name === 'restrict') return 'Design Restriction';
  if(name === 'designClass') return 'Design Class';
}